import { all, call } from 'redux-saga/effects';

import { watchAuthenticationSaga } from './authentication';
import { watchDataElementsSaga } from './dataElements';
import { watchPlayerWebsocket } from '../ws/ws';
import { watchTemplatizationWebsocket } from '../ws/wsTemplatization';

export function* rootSaga() {
  yield all([
    call(watchAuthenticationSaga),
    call(watchDataElementsSaga),
    call(watchPlayerWebsocket),
    call(watchTemplatizationWebsocket),
  ]);
}
